<div role="alert" aria-live="assertive" aria-atomic="true" class="position-fixed bottom-0 end-0 m-4" style="z-index: 999;">
	<button type="button" class="btn shadow rounded-pill p-3" data-bs-toggle="modal" data-bs-target="#help-modal">
		<div class="hyperion-t6">
			{{ languageService.getTranslation('TOAST.HELP.TITLE') | async }}
		</div>
	</button>
</div>
